<template>
  <div class="pricelists" v-if="$store.state.schema['ticket-price-list']">
    <md-table v-if="$store.state.pageLoaded" class="pricelists-table">
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <md-button class="md-icon-button md-raised md-accent" title="Dodaj popust" v-on:click="editCreateDialogVisible = createDialog = true; $store.state.selectedObject = JSON.parse(JSON.stringify(emptyPricelist))" v-if="$store.state.schema['ticket-price-list'].create">
            <md-icon>add</md-icon>
          </md-button>
          <h1 class="md-title">Cjenici</h1>
        </div>
      </md-table-toolbar>

      <md-table-row>
        <md-table-head>Naziv</md-table-head>
        <md-table-head class="t-align-center">Akcije</md-table-head>
      </md-table-row>

      <md-table-row md-selectable="single" md-auto-select v-for="item in $store.state.receivedData.pricelistsList.list">
        <md-table-cell>{{ item.title }}</md-table-cell>
        <md-table-cell class="t-align-center actions-cell">
          <md-button class="md-icon-button md-accent" title="Obriši" v-on:click="deleteDialog = true; $store.state.selectedObject = JSON.parse(JSON.stringify(item))" v-if="$store.state.schema['ticket-price-list'].delete">
            <md-icon>delete</md-icon>
          </md-button>
          <md-button v-on:click="editCreateDialogVisible = true; $store.state.selectedObject = JSON.parse(JSON.stringify(item)); extendPricelist(item)" class="md-icon-button" title="Uredi">
            <md-icon>edit</md-icon>
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>

    <md-dialog-confirm :md-active.sync="deleteDialog"
                md-title="Brisanje cjenika"
                md-content="Jeste li sigurni?"
                md-confirm-text="Obriši"
                md-cancel-text="Zatvori"
                v-on:md-confirm="deleteSelected"
                >
    </md-dialog-confirm>

    <md-dialog :md-active.sync="editCreateDialogVisible" class="md-scrollbar pricelist-dialog">
      <md-dialog-title>{{ getDialogTitle }}</md-dialog-title>
      <md-card>
        <md-card-content>
          <div class="md-layout">
            <md-field :class="messageClass('title', $store.state.selectedObject)">
              <label>Naziv</label>
              <md-input required type="text" v-model="$store.state.selectedObject.title"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-table v-if="editCreateDialogVisible">
              <md-table-row>
                <md-table-cell></md-table-cell>
                <md-table-cell v-for="i in Array.from({length: 5}, (x,i) => i)">
                  <md-checkbox v-model="activeCategories" :value="i" :disabled="i == 1">
                    <span v-if="i == 0">Proscenij</span>
                    <span v-else>{{ i }}. kategorija</span>
                  </md-checkbox>
                </md-table-cell>
              </md-table-row>
              <md-table-row v-for="discount in $store.state.receivedData.discounts.list">
                <md-table-cell>
                  <md-checkbox v-model="activeDiscounts" :value="discount.id" :disabled="['regular'].includes(discount.kind)">
                    {{ discount.description }}
                  </md-checkbox>
                </md-table-cell>
                <md-table-cell v-for="category, categoryKey in $store.state.selectedObject.data.category">
                  <md-field>
                  <md-input type="text" :disabled="!activeCategories.includes(parseInt(categoryKey)) || !activeDiscounts.includes(parseInt(discount.id))" v-model="$store.state.selectedObject.data.category[categoryKey][discount.id]" v-on:input="recalculatePrice(discount.kind == 'regular', categoryKey, $store.state.selectedObject.data.category[categoryKey][discount.id])"/>
                  </md-field>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </div>
          <md-dialog-actions>
            <md-button v-on:click="editCreateDialogVisible = false;">Zatvori</md-button>
            <md-button v-on:click="validate" class="md-primary" v-if="$store.state.schema['ticket-price-list'].update">Spremi</md-button>
          </md-dialog-actions>
        </md-card-content>
      </md-card>
    </md-dialog>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import ListingMixin from '../../../mixins/listing-mixin.js'
import PricelistMixin from '../../../mixins/pricelist-mixin.js'

export default {
  name: 'Pricelists',
  mixins: [ListingMixin('pricelistsList', 'cjenik'), PricelistMixin('data')],
  data(){
    return {
      requiredFields: ['title'],
    }
  },

  computed: {
    ...mapGetters([
      'isPageLoaded'
    ])
  },

  watch:{
    createDialog(value){
      if(value){
        this.activeCategories.push(1);
        let gratis = this.$store.state.receivedData.discounts.list.filter((discount) =>{return discount.kind == 'gratis'})[0].id;
        let regular = this.$store.state.receivedData.discounts.list.filter((discount) =>{return discount.kind == 'regular'})[0].id;
        let employee = this.$store.state.receivedData.discounts.list.filter((discount) =>{return discount.kind == 'employee'})[0].id;
        this.activeDiscounts = [1];
        this.$store.state.receivedData.discounts.list.forEach((discount) =>{
          this.activeDiscounts.push(discount.id);
        })
        this.createEmptyPricelist();
        this.$store.state.selectedObject = JSON.parse(JSON.stringify(this.emptyPricelist));
      }
    },
  }
}
</script>

<style lang="scss">
  .pricelists-table{
    max-width: 1024px;
  }

  .pricelist-dialog{
    .full-width{
      & + .md-table tbody .md-table-row td{
        border-top: 0
      }
    }
  }

  .pricelist-dialog{
    width: 100%;
    max-width: 1430px;
    overflow-y: scroll;
  }

  .category-number{
    margin: 30px 0;
  }

  input[disabled="disabled"]{
    -webkit-text-fill-color: #ddd !important;
  }

  .md-field.md-disabled:after{
    opacity: 0.2
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Tickets/Pricelists.vue